<template>
	<div class="cart">
		<link
			rel="stylesheet"
			href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
		/>
		<img src="../assets/nail_bar.png" />
		<div id="title">
			<h1>
				Shopping Cart
				<span class="icon">
					<md-icon class="fa fa-shopping-cart"></md-icon>
				</span>
			</h1>
		</div>

		<div class="md-layout md-gutter">
			<div id="table" class="md-layout-item">
				<md-table>
					<md-table-row>
						<md-table-head>Item</md-table-head>
						<md-table-head>Quantity</md-table-head>
						<md-table-head>Price</md-table-head>
					</md-table-row>

					<md-table-row>
						<md-table-cell>
							<md-card class="card">
								<md-card-media>
									<img
										class="item_image"
										src="../assets/nail1.jpg"
										alt="nail2"
									/>
								</md-card-media>
								<md-card-header>
									<div class="md-title">
										Alepia - Premium Liquid Soap (with 15% Laurel Berry Oil)
										500ml
									</div>
								</md-card-header>
							</md-card>
						</md-table-cell>
						<md-table-cell class="no-underline">
							<md-field>
								<md-input
									class="quantity"
									v-model="quant1"
									type="number"
									min="0"
								></md-input>
							</md-field>
						</md-table-cell>
						<md-table-cell class="price">{{ price1 }}.00</md-table-cell>
					</md-table-row>

					<md-table-row>
						<md-table-cell>
							<md-card class="card">
								<md-card-media>
									<img
										class="item_image"
										src="../assets/nail2.jpg"
										alt="nail2"
									/>
								</md-card-media>
								<md-card-header>
									<div class="md-title">
										Alteya Organics - Organic Grapefruit & Zdravetz Lip Balm 5g
									</div>
								</md-card-header>
							</md-card>
						</md-table-cell>
						<md-table-cell class="no-underline">
							<md-field>
								<md-input
									class="quantity"
									v-model="quant2"
									type="number"
									min="0"
								></md-input>
							</md-field>
						</md-table-cell>
						<md-table-cell class="price">{{ price2 }}.00</md-table-cell>
					</md-table-row>

					<md-table-row>
						<md-table-cell>
							<md-card class="card">
								<md-card-media>
									<img
										class="item_image"
										src="../assets/nail3.jpg"
										alt="aleppo"
									/>
								</md-card-media>
								<md-card-header>
									<div class="md-title">
										Alteya Organics - Organic Bulgarian Lavender Water (Amber
										Glass) 120ml
									</div>
								</md-card-header>
							</md-card>
						</md-table-cell>
						<md-table-cell class="no-underline">
							<md-field>
								<md-input
									class="quantity"
									v-model="quant3"
									type="number"
									min="0"
								></md-input>
							</md-field>
						</md-table-cell>
						<md-table-cell class="price">{{ price3 }}.00</md-table-cell>
					</md-table-row>
				</md-table>
			</div>

			<div class="md-layout-item md-size-40">
				<div v-show="!loggedIn">
					<h2>Loyalty Program Login</h2>
					<div>
						<md-field md-clearable>
							<label>Loyalty Program Number</label>
							<md-input v-model="LPId"></md-input>
						</md-field>

						<md-field>
							<label>Password</label>
							<md-input type="password" v-model="password"></md-input>
						</md-field>
						<md-button class="md-raised md-primary loginBtn" v-on:click="login"
							>Login</md-button
						>
					</div>
				</div>

				<div v-show="loggedIn">
					<h2>Loyalty Program</h2>
					<div class="LP_details">
						<md-field class="LP_details">
							<label>Loyalty Program Number</label>
							<md-input class="points" v-model="LPId" readonly></md-input>
						</md-field>
						<p>
							Loyalty points balance:
							<span class="points">{{ LPbalance }}</span>
						</p>
						<md-checkbox v-model="usePoints" class="md-primary"
							>Redeem points for this purchase?</md-checkbox
						>
						<div v-show="usePoints">
							How many points would you like to redeem?
							<div class="md-layout conversion">
								<div class="md-layout-item md-size-40">
									<md-field>
										<label>Points</label>
										<md-input
											v-model.number="redeemPoints"
											type="number"
											min="1"
											:max="LPbalance"
											@input="checkInput"
										></md-input>
									</md-field>
									<div class="disclaimer">*1 point = HKD0.50</div>
								</div>
								<div class="md-layout-item md-size-40 hkdequiv">
									<md-field>
										<label>HKD Equivalent</label>
										<span class="md-prefix">$</span>
										<md-input :value="HKDequiv" readonly></md-input>
									</md-field>
								</div>
							</div>
						</div>
						<p>
							Points earned from this purchase:
							<span class="points">{{ LPearned }}</span>
						</p>
					</div>
					<div class="disclaimer">*1 point earned per 100HKD spent</div>
				</div>

				<div
					v-bind:class="{ total: !loggedIn, total_after: loggedIn }"
					v-show="!usePoints"
				>
					Total (HKD): {{ total }}
				</div>
				<div class="total_after" v-show="usePoints">
					Total (HKD) after redemption: {{ totalRedemption }}
				</div>
			</div>

			<md-dialog-alert
				:md-active.sync="paid"
				md-title="Nail Bar Checkout"
				:md-content="checkoutMessage"
			/>
			<md-dialog-alert
				:md-active.sync="overLimit"
				md-title="Loyalty Points"
				md-content="Redemption amount exceeds total cost of checkout. Please re-enter your amount"
			/>

			<div class="bottom">
				<md-button class="checkoutBtn" @click="checkout"
					>Proceed to Checkout</md-button
				>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";
export default {
	name: "cart",
	data() {
		return {
			quant1: 3,
			quant2: 2,
			quant3: 1,
			LPId: null,
			loggedIn: false,
			LPbalance: null,
			usePoints: false,
			redeemPoints: 1,
			password: null,
			paid: false,
			overLimit: false,
		};
	},
	computed: {
		total() {
			return (this.price1 + this.price2 + this.price3).toFixed(2);
		},
		price1() {
			return this.quant1 * 150;
		},
		price2() {
			return this.quant2 * 90;
		},
		price3() {
			return this.quant3 * 120;
		},
		LPearned() {
			if (!this.usePoints) {
				return Math.floor(this.total / 100);
			} else {
				const earned = Math.floor((this.total - this.HKDequiv) / 100);

				return earned > 0 ? earned : 0;
			}
		},
		HKDequiv() {
			return (this.redeemPoints / 2).toFixed(2);
		},
		totalRedemption() {
			const totalCost = (this.total - this.HKDequiv).toFixed(2);
			return totalCost > 0 ? totalCost : 0;
		},
		checkoutMessage() {
			return `Payment successful`;
		},
	},
	methods: {
		checkout: function () {
			this.paid = true;

			if (this.usePoints) {
				axios
					.post(
						"https://ec2-18-166-2-80.ap-east-1.compute.amazonaws.com/api/v1/tx",
						{
							reciever: "cc913cfa-844e-472b-a515-5d84ab55ff73",
							sender: "dccca5c3-09e5-4c3b-8850-b1a81cf29426",
							amount: this.redeemPoints,
						}
					)
					.then(() => {
						console.log("redeemed");
					});
			}
			// earn points
			axios
				.post(
					"https://ec2-18-166-2-80.ap-east-1.compute.amazonaws.com/api/v1/tx",
					{
						reciever: "dccca5c3-09e5-4c3b-8850-b1a81cf29426",
						sender: "cc913cfa-844e-472b-a515-5d84ab55ff73",
						amount: this.LPearned,
					}
				)
				.then(() => {
					console.log("earned");
				})
				.catch(function (error) {
					console.log(error);
				});
		},
		login: function () {
			this.LPId && this.password ? (this.loggedIn = true) : null;
			axios
				.get(
					`https://ec2-18-166-2-80.ap-east-1.compute.amazonaws.com/api/v1/user`
				)
				.then((response) => {
					this.LPbalance = response.data.data[1].balance;
				})
				.catch((e) => {
					this.errors.push(e);
				});
		},
		checkInput: function () {
			if (this.HKDequiv > this.price1 + this.price2 + this.price3) {
				this.redeemPoints = 1;
				this.overLimit = true;
			}
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
	margin: 40px 0 0;
}
ul {
	list-style-type: none;
	padding: 0;
}
li {
	display: inline-block;
	margin: 0 10px;
}
a {
	color: #42b983;
}

.md-layout {
	margin-top: 60px;
}

.icon {
	margin-left: 10px;
}

.item_image {
	max-width: 100px;
}

.md-card .md-title {
	font-size: 16px;
}

.md-card {
	margin: 4px;
	display: inline-block;
	vertical-align: top;
	box-shadow: none;
}

.md-table-head {
	width: 100px;
	text-align: center;
}
.loyalty {
	margin-left: 200px;
}
.quantity {
	max-width: 50px;
	display: inline-block;
	margin: 0 auto;
	padding: 3px;
	text-align: center;
}

.price {
	font-size: 16px;
}

.checkout-bar {
	width: 100%;
	height: 50px;
	display: inline-flex;
	align-items: flex-end;
	overflow: hidden;
	border: 1px solid rgba(#000, 0.26);
	background: lightblue;
}

#table {
	margin-left: 50px;
}

.md-table-head {
	font-size: 20px;
}

.total {
	text-align: left;
	font-size: 20px;
	font-weight: bold;
	margin-top: 100px;
}

.total_after {
	text-align: left;
	font-size: 20px;
	font-weight: bold;
	margin-top: 30px;
}

.bottom {
	width: 100%;
	height: 50px;
	align-items: flex-end;
	overflow: hidden;
	border: 1px solid rgba(#000, 0.26);
	background-color: lightblue;
}

.bottom .checkoutBtn {
	float: right;
	font-weight: bold;
	font-size: 20px;
	background-color: lightblue !important;
}

.loginBtn {
	float: left;
	background-color: #448aff !important;
	color: white;
}

.LP_details {
	text-align: left;
	font-size: 20px;
}

.points {
	font-size: 30px;
}
.md-switch {
	display: flex;
}

.md-table-row:hover:not(.md-header-row) .md-table-cell {
	background: unset !important;
}
.disclaimer {
	font-size: 15px;
	text-align: left;
}

.md-layout .conversion {
	margin-top: 20px;
}

.hkdequiv {
	margin-left: 20px;
}

.no-underline .md-field.md-theme-default:after {
	background-color: unset;
}
</style>
